module.exports = __webpack_public_path__ + "img/calendar-with-clock.610f2c4e.png";